import { api } from '@/shared/api/generated'
import type { TOTPStatusResponse, EnableTOTPResponse } from '@/shared/api/generated'

export const get2FAStatus = (): Promise<TOTPStatusResponse> => api.get2FAStatus()

export const enable2FA = (password: string): Promise<EnableTOTPResponse> =>
  api.enable2FA({ password })

export const verify2FA = (code: string): Promise<void> =>
  api.verify2FA({ code }).then(() => {})

export const disable2FA = (password: string): Promise<void> =>
  api.disable2FA({ password }).then(() => {})

export const changePassword = (currentPassword: string, newPassword: string): Promise<void> =>
  api.changePassword({ current_password: currentPassword, new_password: newPassword }).then(() => {})
